module.exports = __webpack_public_path__ + "media/svgs/smiley-sad-acfd410126ebc93ec0811923dae8e530.svg";